import request from '@/assets/scripts/utils/request';
// 个人中心

// 个人中心信息获取
export function getUserData(params) {
    return request({
        url: '/ucenter/getUserData',
        method: 'get',
        params
    });
}

// 更新用户信息
export function saveUser(data) {
    return request({
        url: '/ucenter/saveUser',
        method: 'post',
        data
    });
}

// 成果列表
export function getAchievement(params) {
    return request({
        url: '/authuser/getAchievement',
        method: 'get',
        params
    });
}


// 人才需求列表
export function getTalentsList(params) {
    return request({
        url: '/authuser/getTalentsList',
        method: 'get',
        params
    });
}

// 服务需求列表
export function getServeList(params) {
    return request({
        url: '/authuser/getServeList',
        method: 'get',
        params
    });
}

// 技术需求列表
export function getTechnologyList(params) {
    return request({
        url: '/authuser/getTechnologyList',
        method: 'get',
        params
    });
}

// 我报名的会议列表
export function myApplyMeeting(params) {
    return request({
        url: '/meeting/myApplyMeeting',
        method: 'get',
        params
    });
}


// 我的动态列表
export function getWeibolist(params) {
    return request({
        url: '/weibo/getWeibolist',
        method: 'get',
        params
    });
}


